import type {
  EnergyAnalysisCategoryTotal,
  EnergyAnalysisDimension,
  EnergyAnalysisMixCell,
  EnergyAnalysisTrendSeries,
} from "../model/types";

import { ENERGY_ANALYSIS_DIMENSION } from "../model/constants";
import { EnergyAnalysisMixChart } from "./EnergyAnalysisMixChart";
import { EnergyAnalysisSplitCharts } from "./EnergyAnalysisSplitCharts";

type EnergyAnalysisChartsRowProps = {
  categoryTotals: EnergyAnalysisCategoryTotal[];
  dimension: EnergyAnalysisDimension;
  mixCells: EnergyAnalysisMixCell[];
  mixChartTitle: string;
  mixUseTypes: string[];
  mixUtilities: string[];
  snapshotValueMax: number;
  totalChartTitle: string;
  totalValue: number;
  trendChartTitle: string;
  trendSeries: EnergyAnalysisTrendSeries[];
  unit: string;
  years: number[];
};

export const EnergyAnalysisChartsRow = ({
  categoryTotals,
  dimension,
  mixCells,
  mixChartTitle,
  mixUseTypes,
  mixUtilities,
  snapshotValueMax,
  totalChartTitle,
  totalValue,
  trendChartTitle,
  trendSeries,
  unit,
  years,
}: EnergyAnalysisChartsRowProps) => {
  if (dimension === ENERGY_ANALYSIS_DIMENSION.mix) {
    return (
      <EnergyAnalysisMixChart
        cells={mixCells}
        snapshotValueMax={snapshotValueMax}
        title={mixChartTitle}
        unit={unit}
        useTypes={mixUseTypes}
        utilities={mixUtilities}
      />
    );
  }
  return (
    <EnergyAnalysisSplitCharts
      categoryTotals={categoryTotals}
      snapshotValueMax={snapshotValueMax}
      totalChartTitle={totalChartTitle}
      totalValue={totalValue}
      trendChartTitle={trendChartTitle}
      trendSeries={trendSeries}
      unit={unit}
      years={years}
    />
  );
};
